import PropTypes from "prop-types";
import { useState, useEffect } from "react";

const UserEjercicioVerForm = ({ user, getEjercicioByUser_Id, deleteEjercicioBy_Id, putEjercicioByEjercicio_Id }) => {
  const [ejerciciosList, setEjerciciosList] = useState([]);
  const [summaries, setSummaries] = useState([]);
  const [reload, setReload] = useState(false); // Estado de recarga

  useEffect(() => {
    const userId = user?.id_usuario;

    const fetchEjercicios = async () => {
      if (!userId) return;
      try {
        const ejerciciosData = await getEjercicioByUser_Id(userId);
        const data = Array.isArray(ejerciciosData.data) ? ejerciciosData.data : [];
        setEjerciciosList(data);
        calculateSummaries(data);
      } catch (error) {
        console.error("Error fetching ejercicios:", error);
        setEjerciciosList([]);
        setSummaries([]);
      }
    };

    fetchEjercicios();
  }, [user, getEjercicioByUser_Id, reload]);

  const calculateSummaries = (data) => {
    const summaryByType = data.reduce((acc, item) => {
      const { tipo_de_ejercicio, duracion, distancia, calorias } = item;
      if (!acc[tipo_de_ejercicio]) {
        acc[tipo_de_ejercicio] = { duracion: 0, distancia: 0.0, calorias: 0 };
      }
      acc[tipo_de_ejercicio].duracion += duracion || 0;
      let distanciaFloat = isNaN(parseFloat(distancia)) ? 0.0 : parseFloat(distancia);
      acc[tipo_de_ejercicio].distancia += distanciaFloat;
      acc[tipo_de_ejercicio].calorias += calorias || 0;
      return acc;
    }, {});

    setSummaries(Object.entries(summaryByType).map(([tipo, valores]) => ({ tipo, ...valores })));
  };

  const handleDelete = async (ejercicioId) => {
    try {
      await deleteEjercicioBy_Id(ejercicioId);
      setEjerciciosList((prevList) => prevList.filter((ejercicio) => ejercicio.id_ejercicio !== ejercicioId));
      alert("Ejercicio eliminado con éxito.");
    } catch (error) {
      console.error("Error eliminando ejercicio:", error);
      alert("Hubo un error al intentar eliminar el ejercicio.");
    }
  };

  const handleEdit = async (ejercicio) => {
    try {
      ejercicio.distancia=parseFloat(ejercicio.distancia)
      ejercicio.duracion=parseInt(ejercicio.duracion)
      await putEjercicioByEjercicio_Id(ejercicio.id_ejercicio, ejercicio);
      setEjerciciosList((prevList) =>
        prevList.map((item) => (item.id_ejercicio === ejercicio.id_ejercicio ? ejercicio : item))
      );
      alert("Ejercicio actualizado con éxito.");
      setReload(prev => !prev); // Cambia el estado para forzar la recar
    } catch (error) {
      console.error("Error actualizando ejercicio:", error);
      alert("Hubo un error al intentar actualizar el ejercicio.");
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedList = [...ejerciciosList];
    updatedList[index][field] = value;
    setEjerciciosList(updatedList);
  };

  // Función para formatear la fecha
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
  
    // Crear fecha como UTC
    const utcDate = new Date(dateString);
  
    // Ajustar a GMT-6 (360 minutos = 6 horas)
    const localDate = new Date(utcDate.getTime() + 24 * 60 * 60 * 1000);
  
    // Formatear la fecha a 'DD-MM-YYYY'
    return localDate.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="table-container">
      <h3>Resumen por Tipo de Ejercicio</h3>
      <table border="1" className="table">
        <thead>
          <tr>
            <th>Tipo de Ejercicio</th>
            <th>Duración (min)</th>
            <th>Distancia (mts)</th>
            <th>Calorías</th>
          </tr>
        </thead>
        <tbody>
          {summaries.map((summary, index) => (
            <tr key={index}>
              <td>{summary.tipo}{summary.tipo === 'ruta' && `s`}</td>
              <td><center>{summary.duracion}</center></td>
              <td><center>{summary.distancia}</center></td>
              <td><center>{summary.calorias}</center></td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3>Entrenamientos Encontrados</h3>
      <table border="1" className="table">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Tipo Ejercicio</th>
            <th>Duración (min)</th>
            <th>Distancia (mts)</th>
            <th>Calorías</th>
            <th colSpan="2">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {ejerciciosList.map((ejercicio, index) => (
            <tr key={index}>
              <td>
                {formatDate(ejercicio.fecha)}
              </td>
              <td>
                {ejercicio.tipo_de_ejercicio} 
                {ejercicio.tipo_de_ejercicio === 'ruta' && ` (${ejercicio.nombre_ruta})`}
              </td>
              <td>
                <input type="number" value={ejercicio.duracion} onChange={(e) => handleInputChange(index, "duracion", e.target.value)} />
              </td>
              <td>
                <input type="number" value={ejercicio.distancia} onChange={(e) => handleInputChange(index, "distancia", e.target.value)} />
              </td>
              <td>
                <center>{ejercicio.calorias}</center>
              </td>
              <td>
              <button onClick={() => handleEdit(ejercicio)} className="menu-button1">Editar</button>
              </td>
              <td>
                {ejercicio.tipo_de_ejercicio !== "ruta" && (
                  <button onClick={() => handleDelete(ejercicio.id_ejercicio)} className="menu-button1">Borrar</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

UserEjercicioVerForm.propTypes = {
  user: PropTypes.object.isRequired,
  getEjercicioByUser_Id: PropTypes.func.isRequired,
  deleteEjercicioBy_Id: PropTypes.func.isRequired,
  putEjercicioByEjercicio_Id: PropTypes.func,
};

export default UserEjercicioVerForm;
